import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import {
  ArrowLeft,
  ChevronDown,
  ChevronUp,
  Info,
} from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import { setToogleHeader } from "../../../core/redux/action";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Swal from "sweetalert2";
import { api_get, api_post } from "../../../helpers/index";
import Select from "react-select";

const AddGroupTier = () => {
  const route = all_routes;
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const navigate = useNavigate();

  // State for Group Tier details
  const [groupTierName, setGroupTierName] = useState("");
  const [description, setDescription] = useState("");
  const [selectedTiers, setSelectedTiers] = useState([]);
  const [errors, setErrors] = useState({});
  const [tiers, setTiers] = useState([]); // State to store the list of tiers

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  // Fetch the list of tiers from the API
  const fetchTiers = async () => {
    const result = await api_get("tier/list/1");
    if (result.status) {
      const totalPages = result.data.pagination.total_page;
      let allData = result.data.collection;

      for (let page = 2; page <= totalPages; page++) {
        const pageResult = await api_get(`spinwheel/tier/list/${page}`);
        if (pageResult.status) {
          allData = allData.concat(pageResult.data.collection);
        }
      }

      if (allData.length > 0) {
        const tierOptions = allData.map((item) => ({
          value: item.tier_id,
          label: `${item.name} (${item.tier_id})`,
        }));
        setTiers(tierOptions);
      }
    }
  };

  useEffect(() => {
    fetchTiers();
  }, []);

  // Validate input fields
  const validateInputs = () => {
    const newErrors = {};
    if (!groupTierName.trim()) newErrors.groupTierName = "Group tier name is required.";
    if (!description.trim()) newErrors.description = "Description is required.";
    if (description.trim().length > 60) newErrors.description = "Description must not exceed 60 characters.";
    if (selectedTiers.length === 0) newErrors.selectedTiers = "At least one tier must be selected.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle saving the Group Tier
  const handleSaveGroupTier = async () => {
    if (!validateInputs()) {
      return;
    }

    const body = {
      name: groupTierName,
      description: description,
      tier_id: selectedTiers.map(tier => tier.value),
    };

    try {
      const result = await api_post("spinwheel/group_tier/create", body);
      if (result.status === 1) {
        // Show success message with SweetAlert2 and navigate to Group Tier list
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Group Tier created successfully!",
        }).then(() => {
          navigate(route.groupTierList);
        });
      } else {
        // Show error message with SweetAlert2
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to create Group Tier: " + result.message,
        });
      }
    } catch (error) {
      console.error("Error creating Group Tier:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while creating the Group Tier. Please try again later.",
      });
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>New Group Tier</h4>
              <h6>Create new Group Tier</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <div className="page-btn">
                <Link to={route.groupTierList} className="btn btn-secondary">
                  <ArrowLeft className="me-2" />
                  Back to Group Tier
                </Link>
              </div>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Collapse"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => {
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp className="feather-chevron-up" />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>

        <form>
          <div className="card">
            <div className="card-body add-prize pb-0">
              <div className="accordion-card-one accordion" id="accordionExample">
                <div className="accordion-item">
                  <div className="accordion-header" id="headingOne">
                    <div
                      className="accordion-button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-controls="collapseOne"
                    >
                      <div className="addprize-icon">
                        <h5>
                          <Info className="add-info" />
                          <span>Group Tier Information</span>
                        </h5>
                        <Link to="#">
                          <ChevronDown className="chevron-down-add" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div className="row">
                        <div className="col-lg-6 col-sm-6 col-12">
                          <div className="mb-3 add-prize">
                            <label className="form-label">Group Tier Name<span className="text-danger">*</span></label>
                            <input
                              type="text"
                              className={`form-control ${errors.groupTierName ? 'is-invalid' : ''}`}
                              placeholder="Enter group tier name"
                              value={groupTierName}
                              onChange={(e) => setGroupTierName(e.target.value)}
                            />
                            {errors.groupTierName && (
                              <div className="text-danger mt-1">{errors.groupTierName}</div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6 col-sm-6 col-12">
                          <div className="mb-3 add-prize">
                            <label className="form-label">Select Tiers<span className="text-danger">*</span></label>
                            <Select
                              isMulti
                              options={tiers}
                              value={selectedTiers}
                              onChange={setSelectedTiers}
                              className={errors.selectedTiers ? 'is-invalid' : ''}
                              placeholder="Select tiers to include"
                            />
                            {errors.selectedTiers && (
                              <div className="text-danger mt-1">{errors.selectedTiers}</div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-12">
                          <div className="input-blocks summer-description-box transfer mb-3">
                            <label>Description<span className="text-danger">*</span></label>
                            <textarea
                              className={`form-control h-100 ${errors.description ? 'is-invalid' : ''}`}
                              rows={5}
                              placeholder="Enter description"
                              value={description}
                              onChange={(e) => setDescription(e.target.value)}
                            />
                            <p className="mt-1">Maximum 60 Characters</p>
                            {errors.description && (
                              <div className="text-danger mt-1">{errors.description}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="btn-addprize mb-4">
              <button
                type="button"
                className="btn btn-cancel me-2"
                onClick={() => {
                  navigate(route.groupTierList);
                }}
              >
                Cancel
              </button>
              <button type="button" className="btn btn-submit" onClick={handleSaveGroupTier}>
                Save Group Tier
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddGroupTier; 